/**
 * png-export.ts — แปลง SVG รายงาน → PNG ในเบราว์เซอร์ (T102)
 *
 * ใช้ SVG ที่สร้างจาก canonical payload เดียวกับหน้าจอ/Excel → ตัวเลขตรงกันเสมอ
 * (การ rasterize ทำฝั่ง browser เพื่อให้ฟอนต์ไทยแสดงผลถูกต้องโดยไม่ต้องฝังไฟล์ฟอนต์)
 */

/** อ่านขนาดจาก attribute ของ <svg> (fallback 900×1200) */
export function readSvgSize(svg: string): { width: number; height: number } {
  const w = /width="(\d+(?:\.\d+)?)"/.exec(svg);
  const h = /height="(\d+(?:\.\d+)?)"/.exec(svg);
  return {
    width: w ? Number(w[1]) : 900,
    height: h ? Number(h[1]) : 1200,
  };
}

/** แปลง SVG string → PNG Blob ด้วย canvas (scale = ความละเอียด, 2 = retina) */
export async function svgToPngBlob(svg: string, scale = 2): Promise<Blob> {
  const { width, height } = readSvgSize(svg);
  const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }));
  try {
    const img = new Image();
    img.decoding = 'sync';
    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = () => reject(new Error('แปลงภาพรายงานไม่สำเร็จ'));
      img.src = url;
    });
    const canvas = document.createElement('canvas');
    canvas.width = Math.ceil(width * scale);
    canvas.height = Math.ceil(height * scale);
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('เบราว์เซอร์นี้ไม่รองรับการสร้างภาพ');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    ctx.drawImage(img, 0, 0, width, height);
    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error('สร้างไฟล์ PNG ไม่สำเร็จ'));
      }, 'image/png');
    });
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** ดาวน์โหลด Blob เป็นไฟล์ */
export function downloadBlob(blob: Blob, filename: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
